export interface NoDataTypes {
    action: NoDataActionType;
    searchTerm: string;
    componentTitle: string;
    inputSource: NoDataSourceType;
    wrapInACard?: boolean;
    showTitle?: boolean;
    noDataCustomMessage?: string;
    noDataTitleCustomMessage?: string;
}

export enum NoDataActionType {
    error = 'error',
    pageStart = 'pageStart',
    search = 'search',
    filter = 'filter',
    lock = 'lock',
    emptySelect = 'emptySelect',
}

export enum NoDataSourceType {
    chartCard = 'chartCard',
    largeDataCard = 'largeDataCard',
    table = 'table',
    smallDataCard = 'smallDataCard',
    verySmallDataCard = 'verySmallDataCard',
    listOfEntities = 'listOfEntities',
}
